import SubViewOptions from '../SubViewOptions';
import SearchSimple from '../../../../../../components/SearchSimples/SearchSimple';
import {Box} from "@mui/material";
import {CustomSelect} from "../../../../../../components/CustomSelect";
import CustomDateTimePicker from "../../../../../../components/CustomDateTimePicker";
import React from "react";
import SubmissionHistoryTableApp from "./Functionality/SubmissionHistoryTableApp";
import CustomTable from "../../../../../../components/table/CustomTable";
/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle : FullStack
 * @Email : kpozos@ibl.mx
 *
 */
const SubmissionHistoryTable = ({
    subView,
    option,
    changeSubViewManage,
    setBodyForExport,
    searchElement,
    setSearchElement,
    setSimpleSearch,
    search,
    setSearch,
    emptyFields,
    modified,
    setModified
}) => {

    const {
        setResults,
        rowsPerPage,
        tableId,
        searchId,
        thead,
        tbody,
        pagination,
        getActionsButtons,
        item,
        handleChange,
        isAdmin
    } = SubmissionHistoryTableApp({
        searchElement,
        setBodyForExport,
        option,
        modified,
        setModified
    });

    return (
        <>
            <div className='d-flex'>
                <SubViewOptions subView={subView} changeSubViewManage={changeSubViewManage} />

                {isAdmin && <div className='w-100 ml-4'>
                        <SearchSimple
                            id={searchId}
                            setBodyForExport={setBodyForExport}
                            setSearchResults={setResults}
                            searchElement={searchElement}
                            setSearchElement={setSearchElement}
                            optionTable={option}
                            search={search}
                            setSearch={setSearch}
                            rowsPerPage={rowsPerPage}
                            setSimpleSearch={setSimpleSearch}
                            contractorId={null}
                            supplierId={null}
                            attendanceStartDate={new Date(item?.startDate).getTime()}
                            attendanceEndDate={new Date(item?.endDate).getTime()}
                        />
                    </div>
                }
            </div>

            { tbody?.data?.length > 0 &&
                <div className={"row p-0 m-0 mt-4"}>
                    <Box className='col-sm-12 col-md-6 px-0'>
                        <CustomDateTimePicker
                            id={'dp_sh_start_date'}
                            name={'startDate'}
                            onChange={(e) => {
                                handleChange({target: {value: e, name: 'startDate'}});
                            }}
                            trans={'start_date_at_time'}
                            value={item?.startDate}
                            required={true}
                            openTo={'day'}
                            emptyFields={emptyFields}
                        />
                    </Box>
                    <Box className='col-sm-12 col-md-6 pl-sm-0 pl-md-3 pr-0'>
                        <CustomDateTimePicker
                            id={'dp_sh_end_date'}
                            name={'endDate'}
                            onChange={(e) => {
                                handleChange({target: {value: e, name: 'endDate'}});
                            }}
                            trans={'end_date_at_time'}
                            value={item?.endDate}
                            required={true}
                            openTo={'day'}
                            emptyFields={emptyFields}
                        />
                    </Box>
                </div>
            }

            <CustomTable
                tableId={tableId}
                searchId={searchId}
                checkbox={false}
                thead={thead}
                tbody={tbody}
                columnActions={true}
                getActionsButtons={getActionsButtons}
                textNotInformation={"no_attendance_requests_were_found"}
            />
            {pagination()}
        </>
    );
};

export default SubmissionHistoryTable;
